import React, { useEffect, useState } from "react";

import { useDebounce } from "../../../hooks/useDebounce";
import { activeOptions } from "../../../lib/constants";
import { useGetPosTerminals } from "../../../lib/queries/queriesAndMutations";
import { toLocaleStringFormatter } from "../../../utils/utils";
import Loader from "../../shared/Loader";
import Pagination from "../../shared/Pagination";
import ValueFinder from "../../shared/ValueFinder";
import PoaTerminalCard from "./PoaTerminalCard";

const PosTerminalList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;
  const [searchTerm, setSearchTerm] = useState({
    date: "",
    id: "",
    height: "",
  });
  const debouncedQueryParams = useDebounce(searchTerm, 500); // 500ms delay

  const searchHandler = (name, value) => {
    setSearchTerm((prev) => ({ ...prev, [name]: value }));
  };
  const onPageChange = (page) => setCurrentPage(page);

  const {
    data: transactionList,
    isPending,
    refetch,
    isRefetching,
  } = useGetPosTerminals(searchTerm, currentPage, pageSize);

  useEffect(() => {
    setCurrentPage(1);
    refetch();
  }, [debouncedQueryParams, refetch]);

  useEffect(() => {
    refetch();
  }, [currentPage, refetch]);

  if (isPending) {
    return (
      <div className="w-full h-full flex-center">
        <Loader />
      </div>
    );
  }
  return (
    <div className=" bg-white rounded-v-lg p-2 relative flex flex-col overflow-hidden  w-full pb-10">
      <div className=" gap-2 justify-between w-full hidden md:flex ">
        <table className="w-full" id="albums" cellSpacing="0" align="start">
          <thead>
            <tr>
              <th scope="col"> اسم ترمینال </th>
              <th scope="col">شماره ترمینال </th>
              <th scope="col"> شناسه پذیرنده </th>
              <th scope="col"> موجودی</th>
              <th scope="col">وضعیت</th>
            </tr>
            <tr>
              <td className="text-center"></td>
              <td className="text-center"></td>
              <td className="text-center">
                {/* <SearchInput name={"id"} searchTerm={searchTerm} searchHandler={searchHandler} /> */}
              </td>
              <td className="text-center">
                {/* <SearchInput name={"height"} searchTerm={searchTerm} searchHandler={searchHandler} /> */}
              </td>
            </tr>
          </thead>
          <tbody>
            {isRefetching ? (
              <div className="w-full h-full flex-center absolute inset-0  ">
                <Loader />
              </div>
            ) : (
              transactionList?.data.items.map((item, index) => {
                return (
                  <tr id="list" style={{ height: "50px" }}>
                    <td className="text-center">{item?.name}</td>
                    <td className="text-center">{item.terminal_code}</td>
                    <td className="text-center">{item.merchant_code}</td>
                    <td className="text-center">{toLocaleStringFormatter(item.available_balance)} ریال</td>
                    <td className="text-center">
                      <ValueFinder data={activeOptions} title={item.active} />
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <div className="w-full bg-neutral-20 p-2 grid grid-cols-1  lg:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4 gap-4 md:p-2 rounded-[16px]  md:hidden  ">
        {transactionList?.data.count > 0 ? (
          transactionList?.data.items.map((item, index) => (
            <PoaTerminalCard key={index} item={item} refetch={refetch} />
          ))
        ) : (
          <p>آیتمی وجود ندارد ...</p>
        )}
      </div>
      <div className="w-full  rounded-v-lg bg-neutral-00 mx-auto  sticky bottom-0 left-0 ">
        <Pagination
          onPageChange={onPageChange}
          totalCount={transactionList.data?.count || 0}
          siblingCount={1}
          currentPage={currentPage}
          pageSize={pageSize}
          className=""
        />
      </div>
    </div>
  );
};

export default PosTerminalList;
